module.exports = __webpack_public_path__ + "img/help-icon.9e949055.svg";